module.exports = __webpack_public_path__ + "img/caixun_logo.3899f5a5.png";